
import { AppIndicator } from 'react-bootstrap-icons';
import serviceBtnCss from './ServiceButton.module.css';

export const ServiceButton = () => {
    return (
        <div className={serviceBtnCss.btnWrraper}>
            <div className={serviceBtnCss.btn}>
                <AppIndicator className="mobile-icon" size={26} />
            </div>
        </div>
    )
} 